import React from 'react'
import { FiltersSortBar } from 'widgets/FiltersSortBar/FiltersSortBar'
import s from './AssignmentFilters.module.scss'

const filterItems = [
	{ id: 'all', label: 'All' },
	{ id: 'active', label: 'Active' },
	{ id: 'completed', label: 'Completed' },
	{ id: 'low', label: 'Low Completion' },
]

const AssignmentFilters = ({
	gradeTab,
	onGradeTabChange,
	gradeCounts,
	activeFilterIds,
	onActiveFilterChange,
}) => {
	const gradeItems = [
		{ id: 'all', label: 'All', count: gradeCounts?.all || 0 },
		{ id: 'grade_9', label: 'Grade 9', count: gradeCounts?.grade_9 || 0 },
		{ id: 'grade_10', label: 'Grade 10', count: gradeCounts?.grade_10 || 0 },
		{ id: 'grade_11', label: 'Grade 11', count: gradeCounts?.grade_11 || 0 },
		{ id: 'grade_12', label: 'Grade 12', count: gradeCounts?.grade_12 || 0 },
	]

	return (
		<div className={s.wrap}>
			<div className={s.grades}>
				{gradeItems.map(item => (
					<button
						key={item.id}
						type="button"
						className={[s.grade, item.id === gradeTab ? s.gradeActive : '']
							.filter(Boolean)
							.join(' ')}
						onClick={() => onGradeTabChange?.(item.id)}
					>
						<span>{item.label}</span>
						<span className={s.count}>{item.count}</span>
					</button>
				))}
			</div>
			<FiltersSortBar
				baseItems={filterItems}
				activeIds={activeFilterIds}
				onChange={({ activeIds }) => onActiveFilterChange?.(activeIds)}
				showSearch={false}
			/>
		</div>
	)
}

export default AssignmentFilters
